import React from 'react';
import MissionVision from './components/MissionVision';

const Institucionalidad = () => {
    return (
        <>
            <MissionVision />
        </>
    );
};

export default Institucionalidad;
